import Auth from '@/api/auth';

export default {
  namespaced: true,
  state: {
    form: {},
    currentStep: 1,
  },
  mutations: {
    SAVE_FORM(state, { form }) {
      state.form = {
        ...state.form,
        ...form,
      };
    },
    SET_STEP(state, { step }) {
      state.currentStep = step;
    },
  },
  actions: {
    saveForm({ commit }, { form }) {
      commit('SAVE_FORM', { form });
    },
    goToPreviousStep({ state, commit }) {
      commit('SET_STEP', { step: state.currentStep - 1 });
    },
    goToNextStep({ state, commit }) {
      commit('SET_STEP', { step: state.currentStep + 1 });
    },
    async register({ state }) {
      await Auth.register({
        username: state.form.email,
        password: state.form.password,
        mobile: state.form.mobilePhone,
        firstname: state.form.firstName,
        lastname: state.form.lastName,
        code: state.form.authCode,
        discountCode: state.form.discountCode,
        timezone: new Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Paris',
        type: state.form.type,
        rpps: state.form.noIdentification || !state.form.rpps ? null : state.form.rpps,
        adeli: state.form.noIdentification || !state.form.adeli ? null : state.form.adeli,
        practiceAddress: state.form.practiceAddress,
        practiceZipCode: state.form.practicePostalCode,
        practiceCity: state.form.practiceCity,
        practiceCountry: state.form.practiceCountry,
        companyAddress: state.form.usePracticeAddress ? state.form.practiceAddress : state.form.companyAddress,
        companyZipCode: state.form.usePracticeAddress ? state.form.practicePostalCode : state.form.companyPostalCode,
        companyCity: state.form.usePracticeAddress ? state.form.practiceCity : state.form.companyCity,
        companyCountry: state.form.usePracticeAddress ? state.form.practiceCountry : state.form.companyCountry,
        territorialOrganizationType: state.form.territorialOrganizationType,
        territorialOrganizationName: state.form.territorialOrganizationType === null ? null : state.form.territorialOrganizationName,
      });
    },
  },
};
